import React from 'react';
import type { LucideIcon } from 'lucide-react';
import { CheckCircle2, Loader2, X } from 'lucide-react';
import { Timer } from './Timer';

interface TaskItemProps {
  id: string;
  title: string;
  description: string;
  status: 'scheduled' | 'in_progress' | 'completed' | 'failed';
  isActive: boolean;
  onClick: () => void;
  startTime?: string;
  endTime?: string;
  customIcon?: {
    icon: LucideIcon;
    bgColor: string;
    textColor: string;
  };
}

export const TaskItem: React.FC<TaskItemProps> = ({
  title,
  status,
  isActive,
  onClick,
  startTime,
  endTime,
  customIcon,
}) => {
  const StatusIcon = () => {
    if (customIcon) {
      const Icon = customIcon.icon;
      return (
        <div className={`${customIcon.bgColor} p-1.5 rounded-md`}>
          <Icon size={20} className={customIcon.textColor} />
        </div>
      );
    }

    switch (status) {
      case 'completed':
        return (
          <div className="bg-green-50 p-1.5 rounded-md">
            <CheckCircle2 size={20} className="text-green-500" />
          </div>
        );
      case 'in_progress':
      case 'scheduled':
        return (
          <div className="bg-blue-50 p-1.5 rounded-md">
            <Loader2 size={20} className="text-blue-500 animate-spin" />
          </div>
        );
      case 'failed':
        return (
          <div className="bg-red-50 p-1.5 rounded-md">
            <X size={20} className="text-red-500" />
          </div>
        );
    }
  };

  return (
    <button
      onClick={onClick}
      className={`w-full text-left py-4 px-8 hover:bg-accent transition-colors border-b border-zinc-200 ${
        isActive ? 'bg-accent' : ''
      }`}
    >
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <div className="rounded-md">
            <StatusIcon />
          </div>
          <div>
            <p className={`text-sm truncate max-w-[200px] ${isActive ? 'font-bold' : ''}`}>
              {title}
            </p>
          </div>
        </div>
        {startTime && <Timer startTime={startTime} endTime={endTime} />}
      </div>
    </button>
  );
};
